module.exports = __webpack_public_path__ + "static/indelo-9f882b186aea78234ecb1b2602adb13e.png";